import { useRef, useEffect, useMemo, useState } from 'react';

export default function useIntersect() {
    const ref = useRef(null);
    const [isIntersecting, setIsIntersecting] = useState(false);
    const [isIntersect, setIsIntersect] = useState(false);

    const observer = useMemo(
        () =>
            new IntersectionObserver(
                function onIntersect([entry]) {
                    if (entry?.isIntersecting) {
                        setIsIntersecting(true);
                        setIsIntersect(true);
                    } else if (entry.rootBounds) {
                        setIsIntersecting(false);
                    }
                },
                {
                    root: null,
                    rootMargin: '100px 0px 100px 0px',
                    threshold: 0.01,
                }
            ),
        []
    );

    useEffect(() => {
        const element = ref.current;

        if (!element) {
            return;
        }

        observer.observe(element);

        return () => {
            observer.unobserve(element);
        };
    }, [ref.current]);

    return {
        ref,
        isIntersecting,
        isIntersect,
    };
}
